"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Avatar = require("../Avatar");

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

var _IconSvg = require("../IconSvg");

var _IconSvg2 = _interopRequireDefault(_IconSvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledFlex = (0, _styledComponents2.default)(_Flex2.default).withConfig({
  displayName: "SidebarItem__StyledFlex",
  componentId: "sc-1dbpit6-0"
})(["align-items:center;width:100%;visibility:", ";"], p => p.collapsed ? "hidden" : "visible");

const SidebarItemBase = (0, _styledComponents2.default)(_Flex2.default).withConfig({
  displayName: "SidebarItem__SidebarItemBase",
  componentId: "sc-1dbpit6-1"
})(["cursor:pointer;height:48px;&:hover{background-color:rgba(93,105,230,0.08);}position:relative;"]);

const StyledText = (0, _styledComponents2.default)(_Text2.default).withConfig({
  displayName: "SidebarItem__StyledText",
  componentId: "sc-1dbpit6-2"
})(["overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;width:170px;"]);

const SidebarItem = (_ref) => {
  let {
    icon,
    selected,
    title,
    logo,
    caret,
    collapsed
  } = _ref,
      props = _objectWithoutProperties(_ref, ["icon", "selected", "title", "logo", "caret", "collapsed"]);

  return _react2.default.createElement(
    SidebarItemBase,
    _extends({ alignItems: "center" }, props),
    _react2.default.createElement(_Box2.default, {
      width: "4px",
      height: "100%",
      bg: selected ? "primary" : "transparent",
      style: { position: "absolute", top: 0, left: 0 }
    }),
    _react2.default.createElement(
      StyledFlex,
      null,
      _react2.default.createElement(
        _Box2.default,
        { width: 1, height: 1, ml: 3, mr: collapsed ? 0 : 3 },
        icon ? _react2.default.createElement(_IconSvg2.default, {
          name: icon,
          width: "24",
          color: "white",
          opacity: selected ? 1 : 0.7
        }) : _react2.default.createElement(_Avatar2.default, { height: 1, width: 1, src: logo, borderRadius: 4 })
      ),
      _react2.default.createElement(
        StyledFlex,
        { collapsed: collapsed, style: { overflow: "hidden" } },
        _react2.default.createElement(
          StyledText,
          {
            opacity: !selected ? 0.7 : null,
            fontSize: 1,
            color: "white"
          },
          title
        ),
        caret ? _react2.default.createElement(
          _Box2.default,
          { marginLeft: "auto", pt: 1 },
          _react2.default.createElement(_IconSvg2.default, {
            name: caret,
            color: "white",
            width: "24",
            opacity: selected ? 1 : 0.7
          })
        ) : null
      )
    )
  );
};

SidebarItem.propTypes = {
  icon: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  logo: _propTypes2.default.string,
  caret: _propTypes2.default.string,
  collapsed: _propTypes2.default.bool
};

SidebarItem.defaultProps = {
  icon: null,
  selected: false,
  title: "SidebarItem",
  logo: null,
  caret: null
};

exports.default = SidebarItem;